import { defineComponent as _defineComponent } from 'vue'
import { BoxGridItemProps } from './interfaces';
import BoxGridItem from './BoxGridItem.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TileCard',
  props: {
  ...BoxGridItemProps,
  itemClass: {
    type: String,
    default: 'tile-card',
  },
  tileTitle: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const boxGridItemProps = computed(() => {
  const { tileTitle, ...out } = props;
  return out;
});

return { __sfc: true,props, boxGridItemProps, BoxGridItem }
}

})